import { BRAND_NAME } from "@/lib/brand";
import { RESEARCH_CRITERIA } from "@/lib/research/criteria";
import { LANDING_FAQ_ITEMS } from "@/lib/seo/faq-content";
import { absoluteUrl } from "@/lib/seo/site";

/** Статическое описание продукта для tool getProductInfo (без сети). */
export function buildProductInfoPayload() {
  return {
    brand: BRAND_NAME,
    product: "Desk research и валидация бизнес-идей для рынка РФ",
    description:
      "AI research-engine: структурированный отчёт 11+ страниц, scoring по 6 критериям, Wordstat, конкуренты и источники. Решение go/no-go до вложений в продукт.",
    scoring: {
      scale: "1–10 на критерий, итог — взвешенное среднее",
      stopFactor: "Один критерий ≤ 3 — стоп-фактор для вердикта GO",
      criteria: RESEARCH_CRITERIA.map((c) => ({
        key: c.key,
        label: c.label,
        description: c.description,
        weight: c.weight,
      })),
    },
    reportModes: [
      {
        id: "standard",
        label: "С вопросами",
        note: "До 8 уточняющих вопросов перед генерацией",
      },
      {
        id: "professional",
        label: "Запустить сразу",
        note: "Без уточнений — сразу полный отчёт по теме и файлам",
      },
    ],
    faq: LANDING_FAQ_ITEMS,
    links: {
      home: absoluteUrl("/"),
      pricing: absoluteUrl("/#pricing"),
      createReport: absoluteUrl("/reports/create"),
      sampleReport: absoluteUrl("/billing/sample-report"),
      register: absoluteUrl("/register"),
      llmsTxt: absoluteUrl("/llms.txt"),
    },
  };
}

export function buildExampleReportsPayload() {
  const links = buildProductInfoPayload().links;
  return {
    examples: [
      {
        title: "Демо-отчёт (полная структура и scoring)",
        url: links.sampleReport,
        format: "Интерактивная страница на сайте",
      },
    ],
    llmsIndex: {
      title: "llms.txt — описание продукта для LLM",
      url: links.llmsTxt,
    },
    note: "Цены и лимиты тарифов — только через getPricing, не выдумывать.",
  };
}
